import React, {useMemo, useContext, useEffect} from 'react'
import {TeacherContext} from 'teacher/context'
import {styled, FormControlLabel, Checkbox} from 'external/material'

const StyledMainTopics = styled('ul')(maintopicStyles)

export default function MainTopics() {

  const {updateState: update, quizTopics, quizGenerator: {selectedTopics, questionCount}} = useContext(TeacherContext)
    
  function updateQuestionCount (count) {
      if (count != questionCount) {
        update({quizGenerator: {questionCount: {$set: count}}})
      }
  }

  const topics = useMemo(() => {
    return quizTopics.map(topic => {
        const selectedTopic = selectedTopics[topic.name]
        const selected = !!selectedTopic
        const questionCount =  selected ? selectedTopic.questionCount : undefined
        return {...topic, selected, questionCount}
    })
  }, [quizTopics, selectedTopics])
    
  const minQuestionCount = useMemo(() => topics.reduce((count, {selected}) => count + (selected ? 1 : 0), 0), [topics])
  const maxQuestionCount = useMemo(() => topics.reduce((count, {selected, questions}) => count + (selected ? questions : 0), 0), [topics])

  function handleMainTopicChange (id, questionCount, toggle) {
      const selectedTopic = selectedTopics[id]
      const selected = !!selectedTopic
      if (toggle) {
          if (selected) {
            update({quizGenerator: {
                questionCount: {$apply: oldCount => oldCount - selectedTopic.questionCount + questionCount}, 
                selectedTopics: {$unset: [id]}
            }})
          } else {
            update({quizGenerator: {
                questionCount: {$apply: oldCount => oldCount + questionCount}, 
                selectedTopics: {[id]: {$set: {questionCount}}
            }}})
          }
      } else if (selected) {
             update({quizGenerator: {
                questionCount: {$apply: oldCount => oldCount - selectedTopic.questionCount + questionCount}, 
                selectedTopics: {[id]: {$set: {questionCount}}
            }}})
      }
  }

  useEffect(() => {
      if (questionCount < minQuestionCount) updateQuestionCount(minQuestionCount)
      else  if(questionCount > maxQuestionCount) updateQuestionCount(maxQuestionCount)
  }, [questionCount, minQuestionCount, maxQuestionCount])

  return <StyledMainTopics>
        <NumberInput min={minQuestionCount} max={maxQuestionCount} value={questionCount} onChange={updateQuestionCount} />
        <span>{maxQuestionCount}</span>
        {topics.map(topic => (<MainTopic key={topic.name} topic={topic} onChange={handleMainTopicChange} />))}
  </StyledMainTopics>
}

function NumberInput (props) {
    const {min, max, onChange, value} = props

    const range = useMemo(() => max - min, [min, max])
    const readonly = useMemo(() => range == 0, [range])

    function handleKeyDown (e){
       if (/\d/.test(e.key)) return
       const allowedKeys = ["Backspace", "Enter", "Tab"]
       if (allowedKeys.indexOf(e.key) >= 0) return;
       e.preventDefault();
    }
    
    function handleChange (e) {
        const value = parseInt(e.target.value)
        if (isNaN(value)) onChange(min)
        else if (value < min) onChange(min)
        else if (value > max) onChange(max)
        else onChange(value)
    }

    function handleFocus(e) {
        e.currentTarget.select()
    }

    return <input type="text" onFocus={handleFocus} onKeyDown={handleKeyDown} onChange={handleChange} value={value} readOnly={readonly ? 'readonly' : undefined}/>
}

function MainTopic({topic, onChange}) {
    const {name, selected, questions, questionCount} = topic
    return <li>
        <FormControlLabel label={name} control={<Checkbox onChange={() => onChange(name, selected ? 0 : 1, true)} checked={selected} /> } />
        {selected && <>
            <NumberInput type="text" min={1} max={questions} value={questionCount} onChange={count => onChange(name, count)} />
            <span>{questions}</span>
            </>}
        </li>

}

function maintopicStyles () {
    return {
        
    }
}